import script from "./ExamDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ExamDetail.vue?vue&type=style&index=0&id=59fe9b0b&lang=scss"

const __exports__ = script;

export default __exports__